/* tslint:disable */
/* eslint-disable */
/**
 * Distributor API
 * The Cashlink Distributor API enables you to distribute crypto securities and digital securities. It contains all building blocks from investor registration and KYC/AML to brokerage, clearing and settlement processes. While you are in full control of the frontends served to your investors you can use the Cashlink Studio to monitor and manage the activity on your platform.   Note: You cannot access data of investors or investments if they haven\'t been created via the API with your provided API credentials. Also, it\'s not possible to access data of investors that have registered via the Cashlink Signing Module, if you are using this as well.  ### Authentication  Every call to the API must be authenticated via OAuth client credentials. During setup, your point of contact will provide you with your client ID and client secret.   ### Idempotency  For certain POST endpoints, the API uses client-supplied idempotency keys to ensure that requests can be retried safely without performing the same operation twice. Repeated calls to those endpoints with the same idempotency key will return the cached response from the first call. Keys are expected to be set as header parameters with *X-Idempotency-Key*. The recommended approach for interacting with such endpoints is as follows:   - Create a unique, random key, such as a UUIDv4.   - Store the intent to call an endpoint along with the generated key in the client database.   - Flush to disk (e.g. commit an SQL transaction).   - Perform the call to the endpoint.   This ensures that even if the response from the API to a client gets lost, or the client experiences any sort of outage between steps 3 and 4, the client can always safely retry the same action.   If you already have objects corresponding to tasks in the API in your client-side database, you can use their internal IDs as idempotency keys!   ### Monetary values   Monetary values are represented as a combination of amount, decimals & currency. For example, ```{\'amount\': \'40000000\', \'decimals\': 3, \'currency\': \'EUR\'} means \'EUR 40,000.000\'```.   ### Handling documents  The document endpoint can be used to upload documents. Files are uploaded via HTTP multipart. The endpoint will return a document ID that can be used in other requests to refer to that document.   ### Webhooks  You can also register webhooks so that we can notify your application about events with regards to investments. To use that, please provide your point of contact at Cashlink with the following data:   - URL to be used as the target for webhooks  - OAuth client credentials or bearer authentication token so that we can authenticate at your server.  Webhooks are sent every time the status of an investment changes.  **POST <customer-provided URL>**  Webhooks are retried until the called endpoint returns a 2xx.  **Request**  {  \'investment_id\': \'3fa85f64-5717-4562-b3fc-2c963f66afa6\',  \'status\': \'ACCEPTED\',  \'changed_at\': \'2020-12-11T14:59:46.716Z\'  }  ### Concepts  The Cashlink Distributor API is based on the following concepts:  - Persons (legal or natural) that are users on your platform willing to invest are called investors.  - These investors will be able to invest into different financial products issued by different entities. In the API they are called products.  - The purchase of units of such a product takes place within your application and ends with a signed investment contract.  - Now you can create an investment, which contains the investor, the units, the signed investment contract and the accepted date of the investment by the issuer.   - At some point, parts of the investments are returned to the issuer because the outstanding amount has been paid back for example. Such a transaction is called a redemption.    
 *
 * The version of the OpenAPI document: 2.22.0
 * Contact: support@cashlink.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BenefitingPerson,
  BenefitingPersonRequest,
  ExternalBenefitingPerson,
  ExternalBenefitingPersonRequest,
  ExternalError,
  ExternalIdentification,
  ExternalIdentificationRequest,
  ExternalInvestorTypeGroup,
  ExternalManagedWalletCreateRequest,
  ExternalSignedDocument,
  ExternalWallet,
  ExternalWalletRequest,
  ExternalWalletUpdate,
  Investor,
  InvestorNetworth,
  InvestorNetworthQuestion,
  InvestorNetworthRequest,
  InvestorOverview,
  InvestorTask,
  InvestorTaskRequest,
  InvestorWalletSelectionRequest,
  InvestorWizardInfo,
  KycInformation,
  MetaInvestorCreationRequest,
  PaginatedInvestorList,
  PatchedExternalNaturalPersonInvestorCreationRequest,
  PatchedExternalWalletUpdateRequest,
  PatchedInvestorUpdateRequest,
  PatchedWalletUpdateRequest,
  QuestionnaireQuestion,
  RegisterOnlyInvestorCreation,
  RegisterOnlyInvestorCreationRequest,
  UpdateExternalSurveyAnswersRequest,
  UpdateSurveyAnswersRequest,
  WalletUpdate,
} from '../models/index';
import {
    BenefitingPersonFromJSON,
    BenefitingPersonToJSON,
    BenefitingPersonRequestFromJSON,
    BenefitingPersonRequestToJSON,
    ExternalBenefitingPersonFromJSON,
    ExternalBenefitingPersonToJSON,
    ExternalBenefitingPersonRequestFromJSON,
    ExternalBenefitingPersonRequestToJSON,
    ExternalErrorFromJSON,
    ExternalErrorToJSON,
    ExternalIdentificationFromJSON,
    ExternalIdentificationToJSON,
    ExternalIdentificationRequestFromJSON,
    ExternalIdentificationRequestToJSON,
    ExternalInvestorTypeGroupFromJSON,
    ExternalInvestorTypeGroupToJSON,
    ExternalManagedWalletCreateRequestFromJSON,
    ExternalManagedWalletCreateRequestToJSON,
    ExternalSignedDocumentFromJSON,
    ExternalSignedDocumentToJSON,
    ExternalWalletFromJSON,
    ExternalWalletToJSON,
    ExternalWalletRequestFromJSON,
    ExternalWalletRequestToJSON,
    ExternalWalletUpdateFromJSON,
    ExternalWalletUpdateToJSON,
    InvestorFromJSON,
    InvestorToJSON,
    InvestorNetworthFromJSON,
    InvestorNetworthToJSON,
    InvestorNetworthQuestionFromJSON,
    InvestorNetworthQuestionToJSON,
    InvestorNetworthRequestFromJSON,
    InvestorNetworthRequestToJSON,
    InvestorOverviewFromJSON,
    InvestorOverviewToJSON,
    InvestorTaskFromJSON,
    InvestorTaskToJSON,
    InvestorTaskRequestFromJSON,
    InvestorTaskRequestToJSON,
    InvestorWalletSelectionRequestFromJSON,
    InvestorWalletSelectionRequestToJSON,
    InvestorWizardInfoFromJSON,
    InvestorWizardInfoToJSON,
    KycInformationFromJSON,
    KycInformationToJSON,
    MetaInvestorCreationRequestFromJSON,
    MetaInvestorCreationRequestToJSON,
    PaginatedInvestorListFromJSON,
    PaginatedInvestorListToJSON,
    PatchedExternalNaturalPersonInvestorCreationRequestFromJSON,
    PatchedExternalNaturalPersonInvestorCreationRequestToJSON,
    PatchedExternalWalletUpdateRequestFromJSON,
    PatchedExternalWalletUpdateRequestToJSON,
    PatchedInvestorUpdateRequestFromJSON,
    PatchedInvestorUpdateRequestToJSON,
    PatchedWalletUpdateRequestFromJSON,
    PatchedWalletUpdateRequestToJSON,
    QuestionnaireQuestionFromJSON,
    QuestionnaireQuestionToJSON,
    RegisterOnlyInvestorCreationFromJSON,
    RegisterOnlyInvestorCreationToJSON,
    RegisterOnlyInvestorCreationRequestFromJSON,
    RegisterOnlyInvestorCreationRequestToJSON,
    UpdateExternalSurveyAnswersRequestFromJSON,
    UpdateExternalSurveyAnswersRequestToJSON,
    UpdateSurveyAnswersRequestFromJSON,
    UpdateSurveyAnswersRequestToJSON,
    WalletUpdateFromJSON,
    WalletUpdateToJSON,
} from '../models/index';

export interface ExternalDistributorV2InvestorsBenefitingPersonsCreateRequest {
    xIdempotencyKey: string;
    id: string;
    externalBenefitingPersonRequest: ExternalBenefitingPersonRequest;
}

export interface ExternalDistributorV2InvestorsBenefitingPersonsListRequest {
    id: string;
}

export interface ExternalDistributorV2InvestorsCreateRequest {
    xIdempotencyKey: string;
    metaInvestorCreationRequest?: MetaInvestorCreationRequest;
}

export interface ExternalDistributorV2InvestorsIdentificationsCreateRequest {
    xIdempotencyKey: string;
    id: string;
    externalIdentificationRequest?: ExternalIdentificationRequest;
}

export interface ExternalDistributorV2InvestorsIdentificationsListRequest {
    id: string;
}

export interface ExternalDistributorV2InvestorsIdentificationsRetrieveRequest {
    id: string;
    identId: string;
}

export interface ExternalDistributorV2InvestorsPartialUpdateRequest {
    id: string;
    patchedExternalNaturalPersonInvestorCreationRequest?: PatchedExternalNaturalPersonInvestorCreationRequest;
}

export interface ExternalDistributorV2InvestorsRetrieveRequest {
    id: string;
}

export interface ExternalDistributorV2InvestorsSignedDocumentsListRequest {
    id: string;
}

export interface ExternalDistributorV2InvestorsSurveyCreateRequest {
    id: string;
    updateExternalSurveyAnswersRequest: UpdateExternalSurveyAnswersRequest;
}

export interface ExternalDistributorV2InvestorsWalletsEthGenericCreateRequest {
    xIdempotencyKey: string;
    id: string;
    externalWalletRequest: ExternalWalletRequest;
}

export interface ExternalDistributorV2InvestorsWalletsEthManagedCreateRequest {
    xIdempotencyKey: string;
    id: string;
    externalManagedWalletCreateRequest?: ExternalManagedWalletCreateRequest;
}

export interface ExternalDistributorV2InvestorsWalletsListRequest {
    id: string;
}

export interface ExternalDistributorV2InvestorsWalletsPartialUpdateRequest {
    id: string;
    walletId: string;
    patchedExternalWalletUpdateRequest?: PatchedExternalWalletUpdateRequest;
}

export interface ExternalDistributorV2InvestorsWalletsRetrieveRequest {
    id: string;
    walletId: string;
}

export interface InvestorsBenefitingPersonConfirmationCreateRequest {
    id: string;
}

export interface InvestorsBenefitingPersonsCreateRequest {
    id: string;
    benefitingPersonRequest: BenefitingPersonRequest;
}

export interface InvestorsBenefitingPersonsDestroyRequest {
    id: string;
    personId: string;
}

export interface InvestorsBenefitingPersonsListRequest {
    id: string;
    ordering?: string;
    search?: string;
}

export interface InvestorsBenefitingPersonsUpdateRequest {
    id: string;
    personId: string;
    benefitingPersonRequest: BenefitingPersonRequest;
}

export interface InvestorsDefaultWizardRetrieveRequest {
    distributionPlatformName?: string;
}

export interface InvestorsIdentificationRetrieveRequest {
    id: string;
}

export interface InvestorsIdentificationStartNotificationCreateRequest {
    id: string;
}

export interface InvestorsListRequest {
    activeInvestmentsNoMax?: number;
    activeInvestmentsNoMin?: number;
    activeInvestmentsSumMax?: number;
    activeInvestmentsSumMin?: number;
    distributionPlatformId?: string;
    email?: string;
    lastName?: string;
    limit?: number;
    name?: string;
    offset?: number;
    ordering?: string;
    registeredAtAfter?: Date;
    registeredAtBefore?: Date;
    search?: string;
    tokenId?: string;
    tokenIdIsnull?: boolean;
}

export interface InvestorsNetworthAnswersCreateRequest {
    id: string;
    investorNetworthRequest: InvestorNetworthRequest;
}

export interface InvestorsNetworthAnswersRetrieveRequest {
    id: string;
}

export interface InvestorsNetworthResetDestroyRequest {
    id: string;
}

export interface InvestorsOverviewRetrieveRequest {
    id: string;
}

export interface InvestorsPartialUpdateRequest {
    id: string;
    patchedInvestorUpdateRequest?: PatchedInvestorUpdateRequest;
}

export interface InvestorsPrefilledQuestionnaireListRequest {
    id: string;
}

export interface InvestorsRegistrationCreateRequest {
    registerOnlyInvestorCreationRequest: RegisterOnlyInvestorCreationRequest;
}

export interface InvestorsResetWalletSelectionCreateRequest {
    id: string;
}

export interface InvestorsRetrieveRequest {
    id: string;
}

export interface InvestorsSkipWalletSelectionCreateRequest {
    id: string;
}

export interface InvestorsSurveyCreateRequest {
    id: string;
    updateSurveyAnswersRequest: UpdateSurveyAnswersRequest;
}

export interface InvestorsTasksCreateRequest {
    id: string;
    taskId: string;
    investorTaskRequest: InvestorTaskRequest;
}

export interface InvestorsTasksListRequest {
    id: string;
    ordering?: string;
    search?: string;
}

export interface InvestorsWalletSelectionCreateRequest {
    id: string;
    investorWalletSelectionRequest: InvestorWalletSelectionRequest;
}

export interface InvestorsWalletsPartialUpdateRequest {
    id: string;
    walletId: string;
    patchedWalletUpdateRequest?: PatchedWalletUpdateRequest;
}

export interface InvestorsWizardRetrieveRequest {
    id: string;
}

/**
 * 
 */
export class InvestorsApi extends runtime.BaseAPI {

    /**
     * If you have created a legal person as an investor, use this endpoint to provide the data of the benefiting persons of the legal person via the benefiting persons endpoint. If you have created an investment for that legal person, the status of the investment will remain in the KYC_PENDING step until you provide the data of at least a single benefiting person. Please make sure that you\'re only onboarding investors where the benefiting persons are not *politically exposed persons* (PEP). During the KYC/AML process a background check is performed and investments of PEPs may be rejected.
     * Create benefiting persons for an investor
     */
    async externalDistributorV2InvestorsBenefitingPersonsCreateRaw(requestParameters: ExternalDistributorV2InvestorsBenefitingPersonsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExternalBenefitingPerson>>> {
        if (requestParameters['xIdempotencyKey'] == null) {
            throw new runtime.RequiredError(
                'xIdempotencyKey',
                'Required parameter "xIdempotencyKey" was null or undefined when calling externalDistributorV2InvestorsBenefitingPersonsCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling externalDistributorV2InvestorsBenefitingPersonsCreate().'
            );
        }

        if (requestParameters['externalBenefitingPersonRequest'] == null) {
            throw new runtime.RequiredError(
                'externalBenefitingPersonRequest',
                'Required parameter "externalBenefitingPersonRequest" was null or undefined when calling externalDistributorV2InvestorsBenefitingPersonsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xIdempotencyKey'] != null) {
            headerParameters['X-Idempotency-Key'] = String(requestParameters['xIdempotencyKey']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["investors:write"]);
        }

        const response = await this.request({
            path: `/api/external/distributor/v2/investors/{id}/benefiting-persons/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExternalBenefitingPersonRequestToJSON(requestParameters['externalBenefitingPersonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExternalBenefitingPersonFromJSON));
    }

    /**
     * If you have created a legal person as an investor, use this endpoint to provide the data of the benefiting persons of the legal person via the benefiting persons endpoint. If you have created an investment for that legal person, the status of the investment will remain in the KYC_PENDING step until you provide the data of at least a single benefiting person. Please make sure that you\'re only onboarding investors where the benefiting persons are not *politically exposed persons* (PEP). During the KYC/AML process a background check is performed and investments of PEPs may be rejected.
     * Create benefiting persons for an investor
     */
    async externalDistributorV2InvestorsBenefitingPersonsCreate(requestParameters: ExternalDistributorV2InvestorsBenefitingPersonsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExternalBenefitingPerson>> {
        const response = await this.externalDistributorV2InvestorsBenefitingPersonsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List benefiting persons of an investor.
     * List benefiting persons of an investor
     */
    async externalDistributorV2InvestorsBenefitingPersonsListRaw(requestParameters: ExternalDistributorV2InvestorsBenefitingPersonsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExternalBenefitingPerson>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling externalDistributorV2InvestorsBenefitingPersonsList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["investors:read"]);
        }

        const response = await this.request({
            path: `/api/external/distributor/v2/investors/{id}/benefiting-persons/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExternalBenefitingPersonFromJSON));
    }

    /**
     * List benefiting persons of an investor.
     * List benefiting persons of an investor
     */
    async externalDistributorV2InvestorsBenefitingPersonsList(requestParameters: ExternalDistributorV2InvestorsBenefitingPersonsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExternalBenefitingPerson>> {
        const response = await this.externalDistributorV2InvestorsBenefitingPersonsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Investors are natural or legal persons that buy and hold units of a digital security. If you want to create a legal person as an investor add the data inside the ```legal_person``` attribute. In this case, the `natural_person` attribute will be treated as the representative of the company.  If you\'re using the Investment Platform API offering, you\'re required to deliver the date and time on which the investor agreed to an account setup document inside the ```account_setup_accepted_at``` attribute. The document is signed and marked with the investor data after the KYC/AML process for that investor is completed. After that, you are able to retrieve the signed document via the signed documents endpoint for that investor.
     * Create a new investor
     */
    async externalDistributorV2InvestorsCreateRaw(requestParameters: ExternalDistributorV2InvestorsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalInvestorTypeGroup>> {
        if (requestParameters['xIdempotencyKey'] == null) {
            throw new runtime.RequiredError(
                'xIdempotencyKey',
                'Required parameter "xIdempotencyKey" was null or undefined when calling externalDistributorV2InvestorsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xIdempotencyKey'] != null) {
            headerParameters['X-Idempotency-Key'] = String(requestParameters['xIdempotencyKey']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["investors:write"]);
        }

        const response = await this.request({
            path: `/api/external/distributor/v2/investors/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MetaInvestorCreationRequestToJSON(requestParameters['metaInvestorCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalInvestorTypeGroupFromJSON(jsonValue));
    }

    /**
     * Investors are natural or legal persons that buy and hold units of a digital security. If you want to create a legal person as an investor add the data inside the ```legal_person``` attribute. In this case, the `natural_person` attribute will be treated as the representative of the company.  If you\'re using the Investment Platform API offering, you\'re required to deliver the date and time on which the investor agreed to an account setup document inside the ```account_setup_accepted_at``` attribute. The document is signed and marked with the investor data after the KYC/AML process for that investor is completed. After that, you are able to retrieve the signed document via the signed documents endpoint for that investor.
     * Create a new investor
     */
    async externalDistributorV2InvestorsCreate(requestParameters: ExternalDistributorV2InvestorsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalInvestorTypeGroup> {
        const response = await this.externalDistributorV2InvestorsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Investors need valid identification data that is the result of a video identification process. Use this endpoint to create an identification process with the configured provider (IDnow, Lionware, Postident). The API will return a URL where the investor needs to be redirected to. The result data is then available via the API as soon as the investor finished the identity verification.  You don\'t need to add the identification data during the creation of the investor or even before an investment is created. However, for investments to succeed, a valid identification must be set. Otherwise, investments will stay in the KYC_PENDING status.  It\'s possible to also import already existing data of a previously performed identification process. In order to do this, you\'ll need to provide all attributes besides the ```person_id``` attribute. If you haven\'t provided all the attributes we\'ll try to create a new identification process and return a URL. If this fails because there is no identification provider configured, the API will return an error.  For legal persons you may want to add identification data for a benefiting person of that investor. In this case, use the ID of that person in the ```person_id``` attribute. If the person ID is omitted, we\'ll assume that you want to add an identification for the investor in case of a natural person or for the representative in case of a legal person.
     * Create an identification for an investor
     */
    async externalDistributorV2InvestorsIdentificationsCreateRaw(requestParameters: ExternalDistributorV2InvestorsIdentificationsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalIdentification>> {
        if (requestParameters['xIdempotencyKey'] == null) {
            throw new runtime.RequiredError(
                'xIdempotencyKey',
                'Required parameter "xIdempotencyKey" was null or undefined when calling externalDistributorV2InvestorsIdentificationsCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling externalDistributorV2InvestorsIdentificationsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xIdempotencyKey'] != null) {
            headerParameters['X-Idempotency-Key'] = String(requestParameters['xIdempotencyKey']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["investors:write"]);
        }

        const response = await this.request({
            path: `/api/external/distributor/v2/investors/{id}/identifications/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExternalIdentificationRequestToJSON(requestParameters['externalIdentificationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalIdentificationFromJSON(jsonValue));
    }

    /**
     * Investors need valid identification data that is the result of a video identification process. Use this endpoint to create an identification process with the configured provider (IDnow, Lionware, Postident). The API will return a URL where the investor needs to be redirected to. The result data is then available via the API as soon as the investor finished the identity verification.  You don\'t need to add the identification data during the creation of the investor or even before an investment is created. However, for investments to succeed, a valid identification must be set. Otherwise, investments will stay in the KYC_PENDING status.  It\'s possible to also import already existing data of a previously performed identification process. In order to do this, you\'ll need to provide all attributes besides the ```person_id``` attribute. If you haven\'t provided all the attributes we\'ll try to create a new identification process and return a URL. If this fails because there is no identification provider configured, the API will return an error.  For legal persons you may want to add identification data for a benefiting person of that investor. In this case, use the ID of that person in the ```person_id``` attribute. If the person ID is omitted, we\'ll assume that you want to add an identification for the investor in case of a natural person or for the representative in case of a legal person.
     * Create an identification for an investor
     */
    async externalDistributorV2InvestorsIdentificationsCreate(requestParameters: ExternalDistributorV2InvestorsIdentificationsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalIdentification> {
        const response = await this.externalDistributorV2InvestorsIdentificationsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all identifications for given investor.
     * List identifications of an investor
     */
    async externalDistributorV2InvestorsIdentificationsListRaw(requestParameters: ExternalDistributorV2InvestorsIdentificationsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExternalIdentification>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling externalDistributorV2InvestorsIdentificationsList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["investors:read"]);
        }

        const response = await this.request({
            path: `/api/external/distributor/v2/investors/{id}/identifications/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExternalIdentificationFromJSON));
    }

    /**
     * List all identifications for given investor.
     * List identifications of an investor
     */
    async externalDistributorV2InvestorsIdentificationsList(requestParameters: ExternalDistributorV2InvestorsIdentificationsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExternalIdentification>> {
        const response = await this.externalDistributorV2InvestorsIdentificationsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve specified identification for given investor.
     * Retrieve an identification of an investor
     */
    async externalDistributorV2InvestorsIdentificationsRetrieveRaw(requestParameters: ExternalDistributorV2InvestorsIdentificationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalIdentification>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling externalDistributorV2InvestorsIdentificationsRetrieve().'
            );
        }

        if (requestParameters['identId'] == null) {
            throw new runtime.RequiredError(
                'identId',
                'Required parameter "identId" was null or undefined when calling externalDistributorV2InvestorsIdentificationsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["investors:read"]);
        }

        const response = await this.request({
            path: `/api/external/distributor/v2/investors/{id}/identifications/{ident_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"ident_id"}}`, encodeURIComponent(String(requestParameters['identId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalIdentificationFromJSON(jsonValue));
    }

    /**
     * Retrieve specified identification for given investor.
     * Retrieve an identification of an investor
     */
    async externalDistributorV2InvestorsIdentificationsRetrieve(requestParameters: ExternalDistributorV2InvestorsIdentificationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalIdentification> {
        const response = await this.externalDistributorV2InvestorsIdentificationsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a created investor with new data.
     * Update an investor
     */
    async externalDistributorV2InvestorsPartialUpdateRaw(requestParameters: ExternalDistributorV2InvestorsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalInvestorTypeGroup>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling externalDistributorV2InvestorsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["investors:write"]);
        }

        const response = await this.request({
            path: `/api/external/distributor/v2/investors/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedExternalNaturalPersonInvestorCreationRequestToJSON(requestParameters['patchedExternalNaturalPersonInvestorCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalInvestorTypeGroupFromJSON(jsonValue));
    }

    /**
     * Update a created investor with new data.
     * Update an investor
     */
    async externalDistributorV2InvestorsPartialUpdate(requestParameters: ExternalDistributorV2InvestorsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalInvestorTypeGroup> {
        const response = await this.externalDistributorV2InvestorsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve investor information via ID.
     * Retrieve an investor via ID
     */
    async externalDistributorV2InvestorsRetrieveRaw(requestParameters: ExternalDistributorV2InvestorsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalInvestorTypeGroup>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling externalDistributorV2InvestorsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["investors:read"]);
        }

        const response = await this.request({
            path: `/api/external/distributor/v2/investors/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalInvestorTypeGroupFromJSON(jsonValue));
    }

    /**
     * Retrieve investor information via ID.
     * Retrieve an investor via ID
     */
    async externalDistributorV2InvestorsRetrieve(requestParameters: ExternalDistributorV2InvestorsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalInvestorTypeGroup> {
        const response = await this.externalDistributorV2InvestorsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * If you\'re using the Investment Platform API product offering, this endpoint will return a list of signed documents that have been automatically created after the investor has successfully completed the KYC/AML process.
     * List signed documents of an investor
     */
    async externalDistributorV2InvestorsSignedDocumentsListRaw(requestParameters: ExternalDistributorV2InvestorsSignedDocumentsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExternalSignedDocument>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling externalDistributorV2InvestorsSignedDocumentsList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["investors:read"]);
        }

        const response = await this.request({
            path: `/api/external/distributor/v2/investors/{id}/signed-documents/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExternalSignedDocumentFromJSON));
    }

    /**
     * If you\'re using the Investment Platform API product offering, this endpoint will return a list of signed documents that have been automatically created after the investor has successfully completed the KYC/AML process.
     * List signed documents of an investor
     */
    async externalDistributorV2InvestorsSignedDocumentsList(requestParameters: ExternalDistributorV2InvestorsSignedDocumentsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExternalSignedDocument>> {
        const response = await this.externalDistributorV2InvestorsSignedDocumentsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * If you use the Investment as a service API use this endpoint to update the survey information for an investor. Every time an invitation is created for an investor, update ```survey``` and ```survey_submitted_at``` by POSTing to this endpoint. Retrieve the survey for an invitation via GET /invitations/:id/. On the invitation you will also see whether a waiver is necessary or not. This endpoint supersedes the possibility to set ```survey``` and ```survey_submitted_at``` on the /invitations/ endpoint. 
     * Update survey answers and submitted date of an investor
     */
    async externalDistributorV2InvestorsSurveyCreateRaw(requestParameters: ExternalDistributorV2InvestorsSurveyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling externalDistributorV2InvestorsSurveyCreate().'
            );
        }

        if (requestParameters['updateExternalSurveyAnswersRequest'] == null) {
            throw new runtime.RequiredError(
                'updateExternalSurveyAnswersRequest',
                'Required parameter "updateExternalSurveyAnswersRequest" was null or undefined when calling externalDistributorV2InvestorsSurveyCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["investors:write"]);
        }

        const response = await this.request({
            path: `/api/external/distributor/v2/investors/{id}/survey/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateExternalSurveyAnswersRequestToJSON(requestParameters['updateExternalSurveyAnswersRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * If you use the Investment as a service API use this endpoint to update the survey information for an investor. Every time an invitation is created for an investor, update ```survey``` and ```survey_submitted_at``` by POSTing to this endpoint. Retrieve the survey for an invitation via GET /invitations/:id/. On the invitation you will also see whether a waiver is necessary or not. This endpoint supersedes the possibility to set ```survey``` and ```survey_submitted_at``` on the /invitations/ endpoint. 
     * Update survey answers and submitted date of an investor
     */
    async externalDistributorV2InvestorsSurveyCreate(requestParameters: ExternalDistributorV2InvestorsSurveyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.externalDistributorV2InvestorsSurveyCreateRaw(requestParameters, initOverrides);
    }

    /**
     * In order to receive digital securities during the settlement process, investors need wallets. Use this endpoint to create a wallet for an investor. An investor can also have more than one wallet.  A wallet address is always connected to a single investor identity. It cannot be shared between investors.  You can create an investment for an investor without a wallet present. However, for the settlement process to finish a wallet needs to be set.
     * Create a new Ethereum wallet for an investor
     */
    async externalDistributorV2InvestorsWalletsEthGenericCreateRaw(requestParameters: ExternalDistributorV2InvestorsWalletsEthGenericCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalWallet>> {
        if (requestParameters['xIdempotencyKey'] == null) {
            throw new runtime.RequiredError(
                'xIdempotencyKey',
                'Required parameter "xIdempotencyKey" was null or undefined when calling externalDistributorV2InvestorsWalletsEthGenericCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling externalDistributorV2InvestorsWalletsEthGenericCreate().'
            );
        }

        if (requestParameters['externalWalletRequest'] == null) {
            throw new runtime.RequiredError(
                'externalWalletRequest',
                'Required parameter "externalWalletRequest" was null or undefined when calling externalDistributorV2InvestorsWalletsEthGenericCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xIdempotencyKey'] != null) {
            headerParameters['X-Idempotency-Key'] = String(requestParameters['xIdempotencyKey']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["investors:write"]);
        }

        const response = await this.request({
            path: `/api/external/distributor/v2/investors/{id}/wallets/eth-generic/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExternalWalletRequestToJSON(requestParameters['externalWalletRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalWalletFromJSON(jsonValue));
    }

    /**
     * In order to receive digital securities during the settlement process, investors need wallets. Use this endpoint to create a wallet for an investor. An investor can also have more than one wallet.  A wallet address is always connected to a single investor identity. It cannot be shared between investors.  You can create an investment for an investor without a wallet present. However, for the settlement process to finish a wallet needs to be set.
     * Create a new Ethereum wallet for an investor
     */
    async externalDistributorV2InvestorsWalletsEthGenericCreate(requestParameters: ExternalDistributorV2InvestorsWalletsEthGenericCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalWallet> {
        const response = await this.externalDistributorV2InvestorsWalletsEthGenericCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new managed ethereum wallet for specified investor. This endpoint can be safely called multiple times with the same X-Idempotency-Key.
     * Create
     */
    async externalDistributorV2InvestorsWalletsEthManagedCreateRaw(requestParameters: ExternalDistributorV2InvestorsWalletsEthManagedCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalWallet>> {
        if (requestParameters['xIdempotencyKey'] == null) {
            throw new runtime.RequiredError(
                'xIdempotencyKey',
                'Required parameter "xIdempotencyKey" was null or undefined when calling externalDistributorV2InvestorsWalletsEthManagedCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling externalDistributorV2InvestorsWalletsEthManagedCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xIdempotencyKey'] != null) {
            headerParameters['X-Idempotency-Key'] = String(requestParameters['xIdempotencyKey']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["investors:write"]);
        }

        const response = await this.request({
            path: `/api/external/distributor/v2/investors/{id}/wallets/eth-managed/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExternalManagedWalletCreateRequestToJSON(requestParameters['externalManagedWalletCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalWalletFromJSON(jsonValue));
    }

    /**
     * Create a new managed ethereum wallet for specified investor. This endpoint can be safely called multiple times with the same X-Idempotency-Key.
     * Create
     */
    async externalDistributorV2InvestorsWalletsEthManagedCreate(requestParameters: ExternalDistributorV2InvestorsWalletsEthManagedCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalWallet> {
        const response = await this.externalDistributorV2InvestorsWalletsEthManagedCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List wallets for given investor.
     * List wallets of an investor
     */
    async externalDistributorV2InvestorsWalletsListRaw(requestParameters: ExternalDistributorV2InvestorsWalletsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExternalWallet>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling externalDistributorV2InvestorsWalletsList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["investors:read"]);
        }

        const response = await this.request({
            path: `/api/external/distributor/v2/investors/{id}/wallets/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExternalWalletFromJSON));
    }

    /**
     * List wallets for given investor.
     * List wallets of an investor
     */
    async externalDistributorV2InvestorsWalletsList(requestParameters: ExternalDistributorV2InvestorsWalletsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExternalWallet>> {
        const response = await this.externalDistributorV2InvestorsWalletsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a wallet for a given investor
     * Patch a wallet of an investor
     */
    async externalDistributorV2InvestorsWalletsPartialUpdateRaw(requestParameters: ExternalDistributorV2InvestorsWalletsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalWalletUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling externalDistributorV2InvestorsWalletsPartialUpdate().'
            );
        }

        if (requestParameters['walletId'] == null) {
            throw new runtime.RequiredError(
                'walletId',
                'Required parameter "walletId" was null or undefined when calling externalDistributorV2InvestorsWalletsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["investors:write"]);
        }

        const response = await this.request({
            path: `/api/external/distributor/v2/investors/{id}/wallets/{wallet_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"wallet_id"}}`, encodeURIComponent(String(requestParameters['walletId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedExternalWalletUpdateRequestToJSON(requestParameters['patchedExternalWalletUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalWalletUpdateFromJSON(jsonValue));
    }

    /**
     * Update a wallet for a given investor
     * Patch a wallet of an investor
     */
    async externalDistributorV2InvestorsWalletsPartialUpdate(requestParameters: ExternalDistributorV2InvestorsWalletsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalWalletUpdate> {
        const response = await this.externalDistributorV2InvestorsWalletsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve details of a wallet for given investor.
     * Retrieve a wallet of an investor
     */
    async externalDistributorV2InvestorsWalletsRetrieveRaw(requestParameters: ExternalDistributorV2InvestorsWalletsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalWallet>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling externalDistributorV2InvestorsWalletsRetrieve().'
            );
        }

        if (requestParameters['walletId'] == null) {
            throw new runtime.RequiredError(
                'walletId',
                'Required parameter "walletId" was null or undefined when calling externalDistributorV2InvestorsWalletsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["investors:read"]);
        }

        const response = await this.request({
            path: `/api/external/distributor/v2/investors/{id}/wallets/{wallet_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"wallet_id"}}`, encodeURIComponent(String(requestParameters['walletId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalWalletFromJSON(jsonValue));
    }

    /**
     * Retrieve details of a wallet for given investor.
     * Retrieve a wallet of an investor
     */
    async externalDistributorV2InvestorsWalletsRetrieve(requestParameters: ExternalDistributorV2InvestorsWalletsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalWallet> {
        const response = await this.externalDistributorV2InvestorsWalletsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirms the benefiting person for an investor. This is not applicable to a natural person and will return a bad request in such case.
     */
    async investorsBenefitingPersonConfirmationCreateRaw(requestParameters: InvestorsBenefitingPersonConfirmationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsBenefitingPersonConfirmationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/benefiting-person-confirmation/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Confirms the benefiting person for an investor. This is not applicable to a natural person and will return a bad request in such case.
     */
    async investorsBenefitingPersonConfirmationCreate(requestParameters: InvestorsBenefitingPersonConfirmationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.investorsBenefitingPersonConfirmationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * List/add benefiting persons.
     */
    async investorsBenefitingPersonsCreateRaw(requestParameters: InvestorsBenefitingPersonsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BenefitingPerson>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsBenefitingPersonsCreate().'
            );
        }

        if (requestParameters['benefitingPersonRequest'] == null) {
            throw new runtime.RequiredError(
                'benefitingPersonRequest',
                'Required parameter "benefitingPersonRequest" was null or undefined when calling investorsBenefitingPersonsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/benefiting-persons/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BenefitingPersonRequestToJSON(requestParameters['benefitingPersonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BenefitingPersonFromJSON(jsonValue));
    }

    /**
     * List/add benefiting persons.
     */
    async investorsBenefitingPersonsCreate(requestParameters: InvestorsBenefitingPersonsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BenefitingPerson> {
        const response = await this.investorsBenefitingPersonsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async investorsBenefitingPersonsDestroyRaw(requestParameters: InvestorsBenefitingPersonsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsBenefitingPersonsDestroy().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling investorsBenefitingPersonsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/benefiting-persons/{person_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async investorsBenefitingPersonsDestroy(requestParameters: InvestorsBenefitingPersonsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.investorsBenefitingPersonsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * List/add benefiting persons.
     */
    async investorsBenefitingPersonsListRaw(requestParameters: InvestorsBenefitingPersonsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BenefitingPerson>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsBenefitingPersonsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/benefiting-persons/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BenefitingPersonFromJSON));
    }

    /**
     * List/add benefiting persons.
     */
    async investorsBenefitingPersonsList(requestParameters: InvestorsBenefitingPersonsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BenefitingPerson>> {
        const response = await this.investorsBenefitingPersonsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async investorsBenefitingPersonsUpdateRaw(requestParameters: InvestorsBenefitingPersonsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BenefitingPerson>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsBenefitingPersonsUpdate().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling investorsBenefitingPersonsUpdate().'
            );
        }

        if (requestParameters['benefitingPersonRequest'] == null) {
            throw new runtime.RequiredError(
                'benefitingPersonRequest',
                'Required parameter "benefitingPersonRequest" was null or undefined when calling investorsBenefitingPersonsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/benefiting-persons/{person_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BenefitingPersonRequestToJSON(requestParameters['benefitingPersonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BenefitingPersonFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async investorsBenefitingPersonsUpdate(requestParameters: InvestorsBenefitingPersonsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BenefitingPerson> {
        const response = await this.investorsBenefitingPersonsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the default static WizardSteps for the register only flow. This is meant to be used to gather the steps that should normally occur in the register only flow, but before the user/investor is created.
     */
    async investorsDefaultWizardRetrieveRaw(requestParameters: InvestorsDefaultWizardRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestorWizardInfo>> {
        const queryParameters: any = {};

        if (requestParameters['distributionPlatformName'] != null) {
            queryParameters['distribution_platform_name'] = requestParameters['distributionPlatformName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/default-wizard/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestorWizardInfoFromJSON(jsonValue));
    }

    /**
     * Gets the default static WizardSteps for the register only flow. This is meant to be used to gather the steps that should normally occur in the register only flow, but before the user/investor is created.
     */
    async investorsDefaultWizardRetrieve(requestParameters: InvestorsDefaultWizardRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestorWizardInfo> {
        const response = await this.investorsDefaultWizardRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve an identification. Create it if it does not exists.
     */
    async investorsIdentificationRetrieveRaw(requestParameters: InvestorsIdentificationRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<KycInformation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsIdentificationRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/identification/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => KycInformationFromJSON(jsonValue));
    }

    /**
     * Retrieve an identification. Create it if it does not exists.
     */
    async investorsIdentificationRetrieve(requestParameters: InvestorsIdentificationRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<KycInformation> {
        const response = await this.investorsIdentificationRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets the KYC status of an identification to \'started\'.
     */
    async investorsIdentificationStartNotificationCreateRaw(requestParameters: InvestorsIdentificationStartNotificationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsIdentificationStartNotificationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/identification-start-notification/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sets the KYC status of an identification to \'started\'.
     */
    async investorsIdentificationStartNotificationCreate(requestParameters: InvestorsIdentificationStartNotificationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.investorsIdentificationStartNotificationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async investorsListRaw(requestParameters: InvestorsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedInvestorList>> {
        const queryParameters: any = {};

        if (requestParameters['activeInvestmentsNoMax'] != null) {
            queryParameters['active_investments_no_max'] = requestParameters['activeInvestmentsNoMax'];
        }

        if (requestParameters['activeInvestmentsNoMin'] != null) {
            queryParameters['active_investments_no_min'] = requestParameters['activeInvestmentsNoMin'];
        }

        if (requestParameters['activeInvestmentsSumMax'] != null) {
            queryParameters['active_investments_sum_max'] = requestParameters['activeInvestmentsSumMax'];
        }

        if (requestParameters['activeInvestmentsSumMin'] != null) {
            queryParameters['active_investments_sum_min'] = requestParameters['activeInvestmentsSumMin'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['registeredAtAfter'] != null) {
            queryParameters['registered_at_after'] = (requestParameters['registeredAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['registeredAtBefore'] != null) {
            queryParameters['registered_at_before'] = (requestParameters['registeredAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        if (requestParameters['tokenIdIsnull'] != null) {
            queryParameters['token_id_isnull'] = requestParameters['tokenIdIsnull'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedInvestorListFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async investorsList(requestParameters: InvestorsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedInvestorList> {
        const response = await this.investorsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get or save the networth information for an investor.
     */
    async investorsNetworthAnswersCreateRaw(requestParameters: InvestorsNetworthAnswersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestorNetworth>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsNetworthAnswersCreate().'
            );
        }

        if (requestParameters['investorNetworthRequest'] == null) {
            throw new runtime.RequiredError(
                'investorNetworthRequest',
                'Required parameter "investorNetworthRequest" was null or undefined when calling investorsNetworthAnswersCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/networth-answers/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvestorNetworthRequestToJSON(requestParameters['investorNetworthRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestorNetworthFromJSON(jsonValue));
    }

    /**
     * Get or save the networth information for an investor.
     */
    async investorsNetworthAnswersCreate(requestParameters: InvestorsNetworthAnswersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestorNetworth> {
        const response = await this.investorsNetworthAnswersCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get or save the networth information for an investor.
     */
    async investorsNetworthAnswersRetrieveRaw(requestParameters: InvestorsNetworthAnswersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestorNetworth>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsNetworthAnswersRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/networth-answers/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestorNetworthFromJSON(jsonValue));
    }

    /**
     * Get or save the networth information for an investor.
     */
    async investorsNetworthAnswersRetrieve(requestParameters: InvestorsNetworthAnswersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestorNetworth> {
        const response = await this.investorsNetworthAnswersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the networth questions.  They should be submitted with an answer via the \"networth-answers\" route.
     */
    async investorsNetworthQuestionsListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InvestorNetworthQuestion>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/networth-questions/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvestorNetworthQuestionFromJSON));
    }

    /**
     * Get the networth questions.  They should be submitted with an answer via the \"networth-answers\" route.
     */
    async investorsNetworthQuestionsList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InvestorNetworthQuestion>> {
        const response = await this.investorsNetworthQuestionsListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Clear all the networths done by a given investor. WARNING: It deletes them!
     */
    async investorsNetworthResetDestroyRaw(requestParameters: InvestorsNetworthResetDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsNetworthResetDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/networth-reset/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Clear all the networths done by a given investor. WARNING: It deletes them!
     */
    async investorsNetworthResetDestroy(requestParameters: InvestorsNetworthResetDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.investorsNetworthResetDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async investorsOverviewRetrieveRaw(requestParameters: InvestorsOverviewRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestorOverview>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsOverviewRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/overview/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestorOverviewFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async investorsOverviewRetrieve(requestParameters: InvestorsOverviewRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestorOverview> {
        const response = await this.investorsOverviewRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async investorsPartialUpdateRaw(requestParameters: InvestorsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedInvestorUpdateRequestToJSON(requestParameters['patchedInvestorUpdateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async investorsPartialUpdate(requestParameters: InvestorsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.investorsPartialUpdateRaw(requestParameters, initOverrides);
    }

    /**
     * Gets the questionaire associated with an investor
     */
    async investorsPrefilledQuestionnaireListRaw(requestParameters: InvestorsPrefilledQuestionnaireListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<QuestionnaireQuestion>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsPrefilledQuestionnaireList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/prefilled-questionnaire/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(QuestionnaireQuestionFromJSON));
    }

    /**
     * Gets the questionaire associated with an investor
     */
    async investorsPrefilledQuestionnaireList(requestParameters: InvestorsPrefilledQuestionnaireListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<QuestionnaireQuestion>> {
        const response = await this.investorsPrefilledQuestionnaireListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a user and investor
     */
    async investorsRegistrationCreateRaw(requestParameters: InvestorsRegistrationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegisterOnlyInvestorCreation>> {
        if (requestParameters['registerOnlyInvestorCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'registerOnlyInvestorCreationRequest',
                'Required parameter "registerOnlyInvestorCreationRequest" was null or undefined when calling investorsRegistrationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/registration/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterOnlyInvestorCreationRequestToJSON(requestParameters['registerOnlyInvestorCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegisterOnlyInvestorCreationFromJSON(jsonValue));
    }

    /**
     * Creates a user and investor
     */
    async investorsRegistrationCreate(requestParameters: InvestorsRegistrationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegisterOnlyInvestorCreation> {
        const response = await this.investorsRegistrationCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * If before setting up a wallet, an investor decides to choose another wallet type, then this endpoint needs to be called to reset the `add_wallet_later` field.
     */
    async investorsResetWalletSelectionCreateRaw(requestParameters: InvestorsResetWalletSelectionCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsResetWalletSelectionCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/reset-wallet-selection/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * If before setting up a wallet, an investor decides to choose another wallet type, then this endpoint needs to be called to reset the `add_wallet_later` field.
     */
    async investorsResetWalletSelectionCreate(requestParameters: InvestorsResetWalletSelectionCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.investorsResetWalletSelectionCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async investorsRetrieveRaw(requestParameters: InvestorsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Investor>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestorFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async investorsRetrieve(requestParameters: InvestorsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Investor> {
        const response = await this.investorsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The wallet step in the register only flow is optional and thus can be skipped.
     */
    async investorsSkipWalletSelectionCreateRaw(requestParameters: InvestorsSkipWalletSelectionCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsSkipWalletSelectionCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/skip-wallet-selection/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * The wallet step in the register only flow is optional and thus can be skipped.
     */
    async investorsSkipWalletSelectionCreate(requestParameters: InvestorsSkipWalletSelectionCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.investorsSkipWalletSelectionCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Used to create or update the investor associated survey.
     */
    async investorsSurveyCreateRaw(requestParameters: InvestorsSurveyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsSurveyCreate().'
            );
        }

        if (requestParameters['updateSurveyAnswersRequest'] == null) {
            throw new runtime.RequiredError(
                'updateSurveyAnswersRequest',
                'Required parameter "updateSurveyAnswersRequest" was null or undefined when calling investorsSurveyCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/survey/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSurveyAnswersRequestToJSON(requestParameters['updateSurveyAnswersRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to create or update the investor associated survey.
     */
    async investorsSurveyCreate(requestParameters: InvestorsSurveyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.investorsSurveyCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Execute task
     */
    async investorsTasksCreateRaw(requestParameters: InvestorsTasksCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestorTask>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsTasksCreate().'
            );
        }

        if (requestParameters['taskId'] == null) {
            throw new runtime.RequiredError(
                'taskId',
                'Required parameter "taskId" was null or undefined when calling investorsTasksCreate().'
            );
        }

        if (requestParameters['investorTaskRequest'] == null) {
            throw new runtime.RequiredError(
                'investorTaskRequest',
                'Required parameter "investorTaskRequest" was null or undefined when calling investorsTasksCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/tasks/{task_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters['taskId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvestorTaskRequestToJSON(requestParameters['investorTaskRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestorTaskFromJSON(jsonValue));
    }

    /**
     * Execute task
     */
    async investorsTasksCreate(requestParameters: InvestorsTasksCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestorTask> {
        const response = await this.investorsTasksCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List tasks that the investor needs to do.
     */
    async investorsTasksListRaw(requestParameters: InvestorsTasksListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InvestorTask>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsTasksList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/tasks/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvestorTaskFromJSON));
    }

    /**
     * List tasks that the investor needs to do.
     */
    async investorsTasksList(requestParameters: InvestorsTasksListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InvestorTask>> {
        const response = await this.investorsTasksListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Select a wallet type without creating a wallet immediately. Used for mobile wallet onboarding.
     */
    async investorsWalletSelectionCreateRaw(requestParameters: InvestorsWalletSelectionCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsWalletSelectionCreate().'
            );
        }

        if (requestParameters['investorWalletSelectionRequest'] == null) {
            throw new runtime.RequiredError(
                'investorWalletSelectionRequest',
                'Required parameter "investorWalletSelectionRequest" was null or undefined when calling investorsWalletSelectionCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/wallet-selection/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvestorWalletSelectionRequestToJSON(requestParameters['investorWalletSelectionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Select a wallet type without creating a wallet immediately. Used for mobile wallet onboarding.
     */
    async investorsWalletSelectionCreate(requestParameters: InvestorsWalletSelectionCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.investorsWalletSelectionCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Update a wallet for a given investor
     */
    async investorsWalletsPartialUpdateRaw(requestParameters: InvestorsWalletsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WalletUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsWalletsPartialUpdate().'
            );
        }

        if (requestParameters['walletId'] == null) {
            throw new runtime.RequiredError(
                'walletId',
                'Required parameter "walletId" was null or undefined when calling investorsWalletsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/wallets/{wallet_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"wallet_id"}}`, encodeURIComponent(String(requestParameters['walletId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedWalletUpdateRequestToJSON(requestParameters['patchedWalletUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WalletUpdateFromJSON(jsonValue));
    }

    /**
     * Update a wallet for a given investor
     */
    async investorsWalletsPartialUpdate(requestParameters: InvestorsWalletsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WalletUpdate> {
        const response = await this.investorsWalletsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the WizardSteps for a given investor. Used for the register only flow
     */
    async investorsWizardRetrieveRaw(requestParameters: InvestorsWizardRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestorWizardInfo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling investorsWizardRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/investors/{id}/wizard/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestorWizardInfoFromJSON(jsonValue));
    }

    /**
     * Gets the WizardSteps for a given investor. Used for the register only flow
     */
    async investorsWizardRetrieve(requestParameters: InvestorsWizardRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestorWizardInfo> {
        const response = await this.investorsWizardRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
